import React from 'react';

export const SingleChoiceIcon = () =>
    <>
        <img src="/images/single_choice.png" alt="single choice icon"/>
    </>;

export const MultipleChoiceIcon = () =>
    <>
        <img src="/images/multiple_choice.png"/>
    </>;